<template>
    <div id="data-list-list-view" class="data-list-container">

        <ticket-card  :model="model"/>
        <div class="rtl:mr-8 ltr:ml-8">
            <ticket-card class="mt-8"   v-for="(item,index) in children" :key="index" :model="item" />
        </div>
        <ticket-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData"/>


        <div class="vx-row" style="margin-top: 2.2rem">
            <div class="vx-col w-full pb-10">
                <vx-card>
                    <div class="vx-row">
                        <div class="vx-col w-full flex justify-between">
                            <vs-button @click="addNewData">Send Reply</vs-button>
                        </div>
                    </div>
                </vx-card>
            </div>
        </div>
    </div>
</template>

<script>
    import TicketSidebar from "./comp/TicketSidebar";
    import TicketCard from "./ticket/TicketCard";

    export default {
        components: {
            TicketCard,
            TicketSidebar
        },
        data() {
            return {
                selected: [],
                // products: [],
                itemsPerPage: 4,
                isMounted: false,

                // Data Sidebar
                addNewDataSidebar: false,
                sidebarData: {},
            }
        },
        computed: {
            id(){
                return this.$route.params.id
            },
            model(){
                if(!this.$store.state.ticket.model.id){
                    this.$store.dispatch('ticket/getData' , this.id)
                }
                return this.$store.state.ticket.model;
            },
            children(){
                return this.$store.state.ticket.children;
            }
        },
        methods: {
            addNewData() {
                this.sidebarData = {parent:this.id}
                this.toggleDataSidebar(true)
            },
            deleteData(id) {
                this.$store.dispatch("dataList/removeItem", id)
                    .catch(err => {
                        console.error(err)
                    })
            },
            editData(data) {
                this.sidebarData = data
                this.toggleDataSidebar(true)
            },
            getOrderStatusColor(status) {
                if (status == 1) return "warning"
                if (status == 2) return "success"
                return "primary"
            },
            getPopularityColor(num) {
                if (num > 90) return "success"
                if (num > 70) return "primary"
                if (num >= 50) return "warning"
                if (num < 50) return "danger"
                return "primary"
            },
            toggleDataSidebar(val = false) {
                this.addNewDataSidebar = val;
                this.$store.dispatch('ticket/getChildren' , this.id)
            }
        },

        mounted() {
            this.isMounted = true;
            this.$store.dispatch('ticket/getChildren' , this.id)
        }
    }
</script>

<style lang="scss">
    #data-list-list-view {
        .vs-con-table {

            .product-name {
                max-width: 23rem;
            }

            .vs-table--header {
                display: flex;
                flex-wrap: wrap-reverse;
                margin-left: 1.5rem;
                margin-right: 1.5rem;

                > span {
                    display: flex;
                    flex-grow: 1;
                }

                .vs-table--search {
                    padding-top: 0;

                    .vs-table--search-input {
                        padding: 0.9rem 2.5rem;
                        font-size: 1rem;

                        & + i {
                            right: 1rem;
                        }

                        &:focus + i {
                            right: 1rem;
                        }
                    }
                }
            }

            .vs-table {
                border-collapse: separate;
                border-spacing: 0 1.3rem;
                padding: 0 1rem;

                tr {
                    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

                    td {
                        padding: 20px;

                        &:first-child {
                            border-top-left-radius: .5rem;
                            border-bottom-left-radius: .5rem;
                        }

                        &:last-child {
                            border-top-right-radius: .5rem;
                            border-bottom-right-radius: .5rem;
                        }
                    }

                    td.td-check {
                        padding: 20px !important;
                    }
                }
            }

            .vs-table--thead {
                th {
                    padding-top: 0;
                    padding-bottom: 0;

                    .vs-table-text {
                        text-transform: uppercase;
                        font-weight: 600;
                    }
                }

                th.td-check {
                    padding: 0 15px !important;
                }

                tr {
                    background: none;
                    box-shadow: none;
                }
            }

            .vs-table--pagination {
                justify-content: center;
            }
        }
    }
</style>
